import Avatar from "@material-ui/core/Avatar";
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardHeader from "@material-ui/core/CardHeader";
import CardMedia from "@material-ui/core/CardMedia";
import { red } from "@material-ui/core/colors";
import IconButton from "@material-ui/core/IconButton";
import Link from "@material-ui/core/Link";
import { makeStyles, styled } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import React from "react";
import img from "../../../Image/akash.jpg";
import inbuiltFunctionImg from "../../../Image/BlogImg/inbuiltFunction.PNG";
const MyButton = styled(({ color, ...other }) => <Button {...other} />)({
    background: (props) =>
        props.color === "red"
            ? "linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%)"
            : "linear-gradient(45deg, #2196F3 30%, #21CBF3 90%)",
    border: 0,
    borderRadius: 3,
    boxShadow: (props) =>
        props.color === "red"
            ? "0 3px 5px 2px rgba(255, 105, 135, .3)"
            : "0 3px 5px 2px rgba(33, 203, 243, .3)",
    color: "white",
    height: 38,
    padding: "0 15px",
    margin: 10,
});
const useStyles = makeStyles((theme) => ({
    root: {
        maxWidth: 345,
        "&:hover": {
            vector: [0, 10, 30],
            display: "block",
            boxShadow: "0 14px 28px rgba(0,0,0,0.25), 0 10px 10px rgba(0,0,0,0.22)",
            transition: "boxShadow 0.3s",
            willChange: "transform",
        },
    },
    media: {
        height: 0,
        paddingTop: "56.25%", // 16:9
    },
    expand: {
        transform: "rotate(0deg)",
        marginLeft: "auto",
        transition: theme.transitions.create("transform", {
            duration: theme.transitions.duration.shortest,
        }),
    },
    expandOpen: {
        transform: "rotate(180deg)",
    },
    avatar: {
        backgroundColor: red[500],
    },
    link: {
        textDecoration: "none",
        color: "#fff",
    },
}));

export default function CardContentThree() {
    const classes = useStyles();
    return (
        <Card className={classes.root}>
            <CardHeader
                avatar={
                    <Avatar src={img} aria-label="recipe" className={classes.avatar}>
                        M
                    </Avatar>
                }
                action={
                    <IconButton aria-label="settings">
                        <MoreVertIcon />
                    </IconButton>
                }
                title="Javascript most useful inbuilt function that essential for every JS learner"
                subheader="Apr 27, 2020"
            />
            <CardMedia className={classes.media} image={inbuiltFunctionImg} />
            <CardContent>
                <Typography variant="body2" color="textSecondary" component="p">
                    Undoubtly world one of the best programming languages is JavaScript in
                    2020. More specifically, If you are interested in web technology you
                    have to grasp JavaScript first.
                    <MyButton color="red">
                        <Link className={classes.link} href="https://github.com/akashusr">
                            Read more
                        </Link>
                    </MyButton>
                </Typography>
            </CardContent>
        </Card>
    );
}
